module.exports = __webpack_public_path__ + "static/media/hong.f3b5dc94.png";